import { useSyncExternalStore } from 'react';
import { getBundledCatalog, getCatalog, subscribeCatalog } from './catalog';
export function useCatalog() {
 const catalog=useSyncExternalStore(subscribeCatalog,getCatalog,getBundledCatalog);
 return {status:'ready' as const,catalog};
}
